import { useMemo } from "react";

export type Season = "winter" | "summer";

/**
 * Détecte la saison actuelle basée sur le mois
 * Hiver : novembre (10) → mars (2)
 * Été : avril (3) → octobre (9)
 *
 * Priorité URL : ?theme=summer ou ?theme=winter écrase la détection automatique
 */
export const getSeason = (): Season => {
  // Vérifier le paramètre URL en priorité
  if (typeof window !== "undefined") {
    const urlParams = new URLSearchParams(window.location.search);
    const themeParam = urlParams.get("theme");
    if (themeParam === "summer" || themeParam === "winter") {
      return themeParam;
    }
  }

  // Détection automatique basée sur le mois
  const month = new Date().getMonth(); // 0-11
  // Hiver : novembre (10), décembre (11), janvier (0), février (1), mars (2)
  const isWinter = month >= 9 || month <= 1;

  return isWinter ? "winter" : "summer";
};

/**
 * Hook React pour obtenir la saison actuelle
 * Memoïsé pour éviter les recalculs inutiles
 */
export const useSeason = (): Season => {
  const season = useMemo(() => getSeason(), []);
  return season;
};
